module.exports = __webpack_public_path__ + "static/img/jimmy@2x.db60cdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dalslider/jimmy@2x.png
// module id = 6+tt
// module chunks = 1